<template>
  <b-container style="margin-top: 40px">
    <b-form class="form-horizontal" @submit="submitPatient" @reset="redirectToTable">
      <b-row>
        <b-col md="12">
          <h2>
            Patient data
          </h2>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label-cols-md="3" label-align-md="9" label="Geschlecht *" label-for="inputSex"
                        :state="sexStatus"
                        invalid-feedback="Bitte tragen Sie das Geschlecht des Patienten ein">
            <b-form-select
                id="inputSex"
                type="text"
                v-model="patient.sex"
                :state="sexStatus"
                @input="()=>{if(this.sexStatus===false){this.sexStatus=null;}}"
                placeholder="Geschlecht auswählen">
              <template #first>
                <b-form-select-option value="" disabled>Geschlecht auswählen</b-form-select-option>
              </template>
              <option value="m">Männlich</option>
              <option value="w">Weiblich</option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label-cols-md="3" label-align-md="9" label="Geburtsjahr *" label-for="inputBirthdate"
                        :state="birthDateStatus"
                        invalid-feedback="Bitte tragen Sie das Geburstsjahr des Patienten ein">
            <b-form-input
                id="inputBirthdate"
                type="number"
                placeholder="Geburtsjahr eingeben"
                v-model="birthYear"
                min="1900"
                :max="todayYear-17"
                :state="birthDateStatus"
                @input="()=>{if(this.birthDateStatus===false){this.birthDateStatus=null;}}"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="2">
          <b-button type="reset" variant="outline-danger">
            <div>
              Verwerfen
              <b-icon-trash/>
            </div>
          </b-button>
        </b-col>
        <b-col offset-md="8" md="2" class="text-right">
          <b-button variant="outline-info" type="submit" v-b-hover="handleSaveButtonHover">
            <div>
              CDSS starten
              <span>
                <img v-if=saveButtonHovered src="../assets/brain-blue-full.svg"
                     height="20px"
                     width="20px"
                     alt="icon-blue-full">
            <img v-else src="../assets/brain-blue.svg" height="20px" width="20px" alt="icon-blue"></span>
            </div>
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-container>


</template>

<script>

export default {
  name: "PatientFormular",
  data() {
    return {
      patient: {
        lastName: '',
        firstName: '',
        sex: '',
        birthDate: '',
        caseNumber: '0',
        address: '0',
        postcode: '0',
        city: '0',
        patientId: '0'
      },
      birthYear: '',
      editing: false,
      showAlert: false,
      errorCode: 0,

      birthDateStatus: null,
      sexStatus: null,
      firstNameStatus: null,
      lastNameStatus: null,

      saveButtonHovered: false,
    };
  },
  computed: {
    todayYear() {
      return new Date().getFullYear();
    }
  },
  methods: {
    handleSaveButtonHover(hovered) {
      this.saveButtonHovered = hovered
    },
    submitPatient(event) {
      event.preventDefault()
      this.patient.birthDate = this.birthYear + '-01-01'
      if (this.editing) {
        this.putEditedPatient();
      } else {
        this.createPatient();
      }
      this.topFunction()
    },
    // When the user clicks on the button, scroll to the top of the document
    topFunction() {
      document.getElementById("patient-body").scrollTop = 0;
    },
    createPatient() {
      if (this.checkAllFields()) {
        this.$emit('showCdss', {
          id: 1,
          sex: this.patient.sex,
          birthDate: this.patient.birthDate,
          caseNumber: 1,
          patientId: 1
        })
      }
    },
    redirectToTable() {
      this.patient = {
        lastName: '',
        firstName: '',
        sex: '',
        birthDate: '',
        caseNumber: '0',
        address: '0',
        postcode: '0',
        city: '0',
        patientId: '1'
      }
      this.$router.replace({name: "login"});
    },
    checkAllFields() {
      let pat = this.patient;
      if (this.checkBirthdateField() && pat.sex !== '') {
        return true;
      }
      //this.checkBirthdateField();
      this.sexStatus = this.patient['sex'] !== '' ? null : false;
      return false;
    },
    checkBirthdateField() {
      let input = 'birthDate';
      const pattern = /^\d{4}-\d{2}-\d{2}$/;
      if (!pattern.test(this.patient[input]) || new Date(this.patient[input]) > new Date() || this.patient[input] === '') {
        this.birthDateStatus = false
        return false
      } else {
        this.birthDateStatus = null
        return true
      }
    },
  }
}
</script>

<style scoped>

</style>